import {Model} from "@/store/models/model";
import {User} from "@/store/models/user";
import axios from '@/store/vue-axios'

export class Country extends Model {

  static entity = 'countries'
  static primaryKey = 'code'

  /**
   * @returns {{code: String, is_accountable: Boolean, title: String, users: HasMany}}
   */
  static fields() {
      return {
        code: this.string(''),
        title: this.string(''),
        is_accountable: this.boolean(false),
        users: this.hasMany(User, 'country_code')
      }
  }

  static async fetchCountries(){
    const r = await axios.get('/domain/handles/countries')
    console.log('countries::::',r)
    Country.insertOrUpdate({data:r.data.countries})
  }

  static vSelectOptions(){
    if(Country.all().length === 0) this.fetchCountries()
    const options = Country.all().map(el=>el.title)
    return options
  }

  static returnCode(title){
    console.log('returnCode:::',Country.query().where('title',title).get()[0].code)
    return Country.query().where('title',title).get()[0].code
  }

  static returnTitle(code){
    return this.query().find(code).title
  }



}

export default Country



// WEBPACK FOOTER //
// ./src/store/models/country.js